import { db } from '@/firebase/init'
import { collection, doc } from 'firebase/firestore'

export const setIDOnCreate = (id: string, myCollection: string) => {
  if (id) {
    return id
  }

  const docRef = doc(collection(db, myCollection))
  return docRef.id
}

export function generateFirestoreId(): string {
  return doc(collection(db, '_')).id
}

export function stripFileExtension(filename: string): string {
  return filename.replace(/\.[^./]+$/, '')
}

export function lockBodyScroll() {
  const body = document.body
  const html = document.documentElement

  // Prevent layout jump when hiding scrollbar
  const scrollbarWidth = window.innerWidth - html.clientWidth

  body.dataset.__modalScrollLocked = '1'
  body.style.overflow = 'hidden'
  if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`
}

export function unlockBodyScroll() {
  const body = document.body
  delete body.dataset.__modalScrollLocked
  body.style.overflow = ''
  body.style.paddingRight = ''
}

export function getElementPositionRelativeToViewport(element: HTMLElement): {
  horizontal: 'left' | 'right'
  vertical: 'top' | 'bottom'
} {
  const rect = element.getBoundingClientRect()
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight

  const centerX = rect.left + rect.width / 2
  const centerY = rect.top + rect.height / 2

  const horizontal = centerX < viewportWidth / 2 ? 'left' : 'right'
  const vertical = centerY < viewportHeight / 2 ? 'top' : 'bottom'

  return { horizontal, vertical }
}

